import UserAvatar from "../../components/global/avtar/UserAvatar";
import { formatDate, formatePrice } from "../../utils/utils";

const columns = [
    {
        title: "User",
        dataIndex: "user",
        render: (_, record) => (
            <UserAvatar
                data={{
                    name: record?.name,
                    email: record?.email,
                    profile_image: record?.profilePic,
                }}
            />
        ),
    },
    {
        title: 'Wallet Account No.',
        dataIndex: 'walletAccountNo',
    },
    {
        title: 'Wallet Balance',
        dataIndex: 'balance',
        render: (value) => formatePrice(value),
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        render: (value) => formatePrice(value),
    },
    {
        title: 'Withdraw Type',
        dataIndex: 'withdrawType',
    },
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        render: (value) => formatDate(value),
    },
    {
        title: 'Status',
        dataIndex: 'requestStatus',
    },
];

export default columns;